import { request } from '../utils/Api';

export function getDog(id, accessToken) {
  return dispatch =>
    new Promise((resolve, reject) => {
      request(`dog/${id}`, 'GET', null, {
        Authorization: `Bearer ${accessToken}`,
      }).then(
        response => {
          if (response.status === 200) {
            dispatch({
              type: 'UPDATE_DOG',
              payload: response.data,
            });

            resolve(response.data);
          } else {
            reject();
          }
        },
        err => {
          reject(err);
        },
      );
    });
}

export function createDog(data, accessToken) {
  // eslint-disable-line
  return dispatch =>
    new Promise((resolve, reject) => {
      request('dog', 'POST', data, {
        Authorization: `Bearer ${accessToken}`,
      }).then(
        response => {
          if (response.status === 200) {
            // Create dog endpoint returns entire user object
            dispatch({
              type: 'UPDATE_USER',
              payload: response.data,
            });

            resolve(response.data);
          } else {
            reject();
          }
        },
        err => {
          reject(err);
        },
      );
    });
}

export function updateDogRemote(id, fields, accessToken) {
  return dispatch =>
    new Promise((resolve, reject) => {
      request(`dog/${id}`, 'PATCH', fields, {
        Authorization: `Bearer ${accessToken}`,
      }).then(
        response => {
          if (response.status === 200) {
            dispatch({
              type: 'UPDATE_USER',
              payload: response.data,
            });

            resolve(response.data);
          } else {
            reject();
          }
        },
        err => {
          reject(err);
        },
      );
    });
}

export function requestMatch(id, message, accessToken) {
  return dispatch =>
    new Promise((resolve, reject) => {
      request(`dog/${id}/share`, 'POST', message ? { message } : null, {
        Authorization: `Bearer ${accessToken}`,
      }).then(
        response => {
          if (response.status === 200) {
            dispatch({
              type: 'UPDATE_USER',
              payload: response.data,
            });

            resolve(response.data);
          } else {
            reject();
          }
        },
        err => {
          reject(err);
        },
      );
    });
}

export function toggleFavourite(id, accessToken) {
  return dispatch =>
    new Promise((resolve, reject) => {
      request(`dog/${id}/favourite`, 'POST', null, {
        Authorization: `Bearer ${accessToken}`,
      }).then(
        response => {
          if (response.status === 200) {
            dispatch({
              type: 'UPDATE_USER',
              payload: response.data,
            });

            resolve(response.data);
          } else {
            reject();
          }
        },
        err => {
          reject(err);
        },
      );
    });
}

export function acceptMatch(id, accessToken) {
  return dispatch =>
    new Promise((resolve, reject) => {
      request(`match/${id}/accept`, 'GET', null, {
        Authorization: `Bearer ${accessToken}`,
      }).then(
        response => {
          if (response.status === 200) {
            dispatch({
              type: 'UPDATE_MATCH',
              payload: response.data,
            });

            resolve(response.data);
          } else {
            reject();
          }
        },
        err => {
          reject(err);
        },
      );
    });
}

export function declineMatch(id, message, accessToken) {
  return dispatch =>
    new Promise((resolve, reject) => {
      request(
        `match/${id}/decline`,
        'POST',
        { message },
        {
          Authorization: `Bearer ${accessToken}`,
        },
      ).then(
        response => {
          if (response.status === 200) {
            dispatch({
              type: 'UPDATE_MATCH',
              payload: response.data,
            });

            resolve(response.data);
          } else {
            reject();
          }
        },
        err => {
          reject(err);
        },
      );
    });
}

export function notNowMatch(id, message, accessToken) {
  return dispatch =>
    new Promise((resolve, reject) => {
      request(
        `match/${id}/not-now`,
        'POST',
        { message },
        {
          Authorization: `Bearer ${accessToken}`,
        },
      ).then(
        response => {
          if (response.status === 200) {
            dispatch({
              type: 'UPDATE_MATCH',
              payload: response.data,
            });

            resolve(response.data);
          } else {
            reject();
          }
        },
        err => {
          reject(err);
        },
      );
    });
}

export function endMatch(id, accessToken) {
  return dispatch =>
    new Promise((resolve, reject) => {
      request(`match/${id}/end`, 'GET', null, {
        Authorization: `Bearer ${accessToken}`,
      }).then(
        response => {
          if (response.status === 200) {
            dispatch({
              type: 'UPDATE_MATCH',
              payload: response.data,
            });

            resolve(response.data);
          } else {
            reject();
          }
        },
        err => {
          reject(err);
        },
      );
    });
}

export function cancelMatch(id, accessToken, message = '') {
  return dispatch =>
    new Promise((resolve, reject) => {
      const payload =
        typeof message === 'string' && message.trim().length
          ? {
              message: message.trim(),
            }
          : {};

      request(
        `match/${id}/cancel`,
        'POST',
        payload,
        {
          Authorization: `Bearer ${accessToken}`,
        },
      ).then(
        response => {
          if (response.status === 200) {
            dispatch({
              type: 'UPDATE_MATCH',
              payload: response.data,
            });

            resolve(response.data);
          } else {
            reject();
          }
        },
        err => {
          reject(err);
        },
      );
    });
}

export function logout() {
  return dispatch =>
    new Promise(resolve => {
      dispatch({
        type: 'LOGOUT',
      });

      resolve();
    });
}



// WEBPACK FOOTER //
// ./src/actions/pooch.js